export const sleep = async (ms: number): Promise<boolean> => {
  return new Promise(resolve => {
    setTimeout(resolve, ms)
    return true
  })
}
